<ngx-spinner></ngx-spinner>

@if (showHeader) {
  <div id="header" class="o-mobile-page__header">
    <div class="c-table">
      <div class="c-table__cell valign-bottom">
        <h2 header="health-profile" class="c-heading-mobile">{{ surveyTemplate?.SurveyTitle | translate}}</h2>
      </div>
      @if (allowSkip) {
        <div class="c-table__cell valign-bottom u-text-align-right  u-1/6">
          <button id="skipButton" buttontype="skipButton" type="button" (click)="this.skipSelected()" class="c-mobile-nav-link is-skip-btn">{{ skipTextStringId | translate }}</button>
        </div>
      }
      @if (showHeaderInfoButton) {
        <div class="c-table__cell valign-bottom u-text-align-right  u-1/6">
          <span id="headerInfoModalBtn" class="material-icons info" type="button" (click)="displayHeaderInfoModal()">info_outline</span>
        </div>
      }
    </div>
  </div>
}

<div class="o-mobile-page">
  <div class="o-mobile-page__body has-footer" [ngClass]="[showHeader ? 'has-header' : '', showDialog ? 'is-dialog' : '']">

    <div class="c-survey">

      @if (showDialog) {
        <div class="c-survey__row">
          <app-survey-dialog class="c-survey__top valign-middle" [dialogObj]="dialogObj" [surveyData]="surveyData" (openContactEvent)="handleOpenContactEvent($event)"></app-survey-dialog>
        </div>
      }

      @if (currentQuestion?.Template === 'Image') {
        <div class="c-survey__row">
          <app-survey-image class="c-survey__top" [questionDetails]="currentQuestion" (answerSelectedEvent)="answerSelected($event)"></app-survey-image>
        </div>
      }

      @if (currentQuestion?.Template !== 'Image') {
        <div class="c-survey__row">
          @if (currentQuestion?.Template === 'Button') {
            <app-survey-button class="c-survey__top" [questionDetails]="currentQuestion" [surveyData]="surveyData" (answerSelectedEvent)="answerSelected($event)"></app-survey-button>
          }
          @if (currentQuestion?.Template === 'ButtonMulti') {
            <app-survey-button-multi class="c-survey__top" [questionDetails]="currentQuestion" [surveyData]="surveyData" (answerSelectedEvent)="answerSelected($event)"></app-survey-button-multi>
          }
          @if (currentQuestion?.Template === 'StarRating') {
            <app-star-rating class="c-survey__top" [questionDetails]="currentQuestion" [surveyData]="surveyData" (answerSelectedEvent)="answerSelected($event)"></app-star-rating>
          }
          @if (currentQuestion?.Template === 'PreQuestionDialog') {
            <app-survey-pre-question-dialog class="c-survey__top valign-middle" [dialogObj]="currentQuestion" [surveyData]="surveyData"></app-survey-pre-question-dialog>
          }
          @if (currentQuestion?.Template === 'SurveyCompletedDialog') {
            <app-survey-completed-dialog id="surveyCompletedDialog" class="c-survey__top valign-middle" [dialogObj]="currentQuestion"></app-survey-completed-dialog>
          }
          @if (currentQuestion?.Template === 'BMI') {
            <app-survey-bmi class="c-survey__top" [bmiInfo]="patientBmi" [questionDetails]="currentQuestion" (answerSelectedEvent)="answerSelected($event)"></app-survey-bmi>
          }
          @if (currentQuestion?.Template === 'RadioGroup') {
            <app-survey-radio-group class="c-survey__top" [questionDetails]="currentQuestion" (answerSelectedEvent)="answerSelected($event)"></app-survey-radio-group>
          }
          @if (currentQuestion?.Template === 'ButtonMultiGroup') {
            <app-survey-button-multi-group class="c-survey__top" [questionDetails]="currentQuestion" [surveyData]="surveyData" (answerSelectedEvent)="answerSelected($event)"></app-survey-button-multi-group>
          }
        </div>
      }

      <div class="c-survey__row">
        <div class="c-survey__bottom">
          @for (selectedText of selectedTexts; track selectedText; let i = $index) {
            <div id="postSurveyHelp" class="c-survey__help">
              <span [innerHTML]="selectedText | translate | linky"></span>
            </div>
          }
          @if (selectedAnswer?.AnswerReference) {
            <a id="postSurveyHelpReference" class="c-survey__help" href="{{selectedAnswer?.AnswerReference?.Url}}" target="_blank">{{ selectedAnswer?.AnswerReference?.Text | translate }}</a>
          }
          @if (selectedAnswer?.DisclaimerText) {
            <div id="disclaimer" class="c-survey__help text-left">
              <span [innerHTML]="selectedAnswer?.DisclaimerText | translate | linky"></span>
            </div>
          }
        </div>
      </div>

    </div>

  </div>
</div>

<div class="o-mobile-page__footer">
  <div class="c-table">
    <div class="c-table__cell valign-bottom">
      @if (currentQuestion?.WarningText) {
        <p [innerHTML]="sanitizedWarningText"></p>
      }
      @if (!valid) {
        <p class="c-survey__error u-margin-bottom-small" error="error-message">{{ validationTextStringId | translate }}</p>
      }
      <div><button id="continueButton" type="button" (click)="this.continueSelected()" class="c-btn c-btn--primary">{{ continueText | translate }}</button></div>
      @if (showBackButton) {
        <div class="u-padding-top-small"><button id="backButton" type="button" (click)="this.backSelected()" class="c-btn">{{ "back" | translate }}</button></div>
      }
      @if (cancelText) {
        <div [ngClass]="{'u-padding-top-small': !showBackButton}"><button id="cancelButton" type="button" (click)="this.cancelSelected()" class="c-btn">{{ cancelText | translate }}</button></div>
      }
      @if (currentQuestion?.AllowSkipSection) {
        <div class="u-padding-top-small"><button id="backButton" type="button" (click)="this.skipSection(currentQuestion.NumScreensInSection)" class="c-btn">{{ skipTextStringId | translate }}</button></div>
      }
      @if (this.footer != null){
        <div class="u-padding-top-small"><span class="footer" id="footer" [innerHTML]="footer | translate"></span></div>
      }
    </div>
  </div>
</div>
